import "../../styles/Landing.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LandingSlider from "./LandingSlider";
import slides from "../carouselInfo.json";

function Landing() {
   return (
      <div className="landing" id="landing">
         <Container fluid className="forTest">
            <Row className=" align-items-center">
               <Col xs={8} md={5}>
                  <div className="landTe">
                     <p>نقدم لك خدمات ERP لادارة وتخطيط موارد المؤسسات</p>
                  </div>
               </Col>
               <Col xs={4} md={7}>
                  <div className="earthPic"></div>
               </Col>
            </Row>
         </Container>
         <LandingSlider slides={slides} />
      </div>
   );
}

export default Landing;
